module.exports = __webpack_public_path__ + "media/journey-2.ba1d4f9f.mp4";